import Table from '../../../../../../shared/Tables/Table'
import { useRecoilValue } from 'recoil'
import maintenanceBlankSchemasAtom from '../../maintenanceBlankSchemas.atom.ts'
import useRegularTable from '../../../../../../shared/Tables/Table/ctrl/useRegularTable.ts'
import maintenanceBlanksTableFields from './maintenanceBlanks.table.fields.ts'
import MaintenanceBlankSidePage from '../MaintenanceBlankSidePage'
import useSidePageWithTableCtrl from '@/shared/SidePage/useSidePageWithTableCtrl.ts'

const MaintenanceBlanksTable = () => {
  const items = useRecoilValue(maintenanceBlankSchemasAtom).items
  const sidePageCtrl = useSidePageWithTableCtrl(items)

  const tableCtrl = useRegularTable({
    fields: maintenanceBlanksTableFields,
    tableKey: `maintenance/blank-schemas`,
    itemKey: 'id',
    items: items,
  })

  return (
    <>
      <Table
        {...tableCtrl}
        items={items as any}
        itemKey="id"
        onClick={sidePageCtrl.handleItemPageOpen}
        loading={false}
      />
      <MaintenanceBlankSidePage
        open={sidePageCtrl.sidePageOpen}
        onClose={sidePageCtrl.handleClosePage}
        id={sidePageCtrl.selectedItem?.id}
        onCloseAnimationEnd={sidePageCtrl.handleCloseAnimationEnd}
      />
    </>
  )
}

export default MaintenanceBlanksTable
